/**
 * Fiskal Cloud Notification API
 * # Changelog ## 1.0.0 * Initial Admin API 
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: info@deutsche-fiskal.de
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Entity type: * `BUSINESS_PREMISES` - Business Premises * `ORGANIZATION` - Organization * `TENANT` - Tenant * `ALL` - All tenants 
 */
export enum TargetTypeDTO {
    BUSINESS_PREMISES = 'BUSINESS_PREMISES',
    ORGANIZATION = 'ORGANIZATION',
    TENANT = 'TENANT',
    ALL = 'ALL'
}

export class ClsTargetTypeDTO {
    BUSINESS_PREMISES = 'BUSINESS_PREMISES';
    ORGANIZATION = 'ORGANIZATION';
    TENANT = 'TENANT';
    ALL = 'ALL';
}

